import { render, staticRenderFns } from "./ScheduleProductDressSave.vue?vue&type=template&id=151c626d"
import script from "./ScheduleProductDressSave.vue?vue&type=script&lang=js"
export * from "./ScheduleProductDressSave.vue?vue&type=script&lang=js"
import style0 from "./ScheduleProductDressSave.vue?vue&type=style&index=0&id=151c626d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports